<template>
  <div class="play">
    <div class="bar">
      <span class="back" @click="back">‹</span>
    </div>
    <div class="player">
      <video id="my-video" class="video-js vjs-big-play-centered" playsinline webkit-playsinline></video>
    </div>
    <div class="intro">
      <div class="intro-title">{{ $t('video.intro_title') }} No.{{ current.id }}</div>
      <p class="intro-desc">{{ $t('video.intro') }}</p>
    </div>
    <div class="hot-head">{{ $t('video.hot') }}</div>
    <div class="grid">
      <div class="card" v-for="m in others" :key="m.id" @click="switchTo(m.id)">
        <img :src="m.pic" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import videojs from 'video.js';
import 'videojs-contrib-hls';
import { movieList, movieById } from './catalog';

export default {
  data() {
    return {
      current: movieById(1),
      movies: movieList(),
      player: null,
      is_play: false,
      is_see: 0,
      times: null,
    };
  },
  computed: {
    others() {
      return this.movies.filter((m) => m.id !== this.current.id);
    },
  },
  methods: {
    back() {
      this.$router.push({ path: '/Video' });
    },
    scrollToTop() {
      const go = () => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        if (this.$el && this.$el.scrollIntoView) {
          this.$el.scrollIntoView(true);
        }
      };
      go();
      this.$nextTick(go);
      setTimeout(go, 50);
    },
    switchTo(id) {
      this.scrollToTop();
      if (Number(this.$route.query.id) === Number(id)) {
        this.loadMovie(id);
        return;
      }
      this.$router.replace({ path: '/PlayVideo', query: { id } });
    },
    loadMovie(id) {
      this.current = movieById(id);
      this.scrollToTop();
      this.$nextTick(() => {
        this.applySource();
        this.scrollToTop();
      });
    },
    applySource() {
      if (!this.player || !this.current) return;
      this.player.pause();
      this.player.poster(this.current.pic);
      this.player.src([{ src: this.current.url, type: 'application/x-mpegURL' }]);
      this.player.currentTime(0);
    },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then((res) => {
        if (res && res.code === 200 && res.data) {
          this.is_see = res.data.is_see;
          if (res.data.status !== 1) {
            this.$toast(this.$t('video.account_out'));
            localStorage.clear();
            this.$router.push({ path: '/Login' });
            return;
          }
        }
        this.applySource();
      }).catch(() => {
        this.applySource();
      });
    },
  },
  watch: {
    '$route.query.id'(id) {
      this.loadMovie(id);
    },
  },
  mounted() {
    const _this = this;
    this.current = movieById(this.$route.query.id);
    this.player = videojs('my-video', {
      height: '210px',
      preload: 'auto',
      controls: true,
      poster: this.current.pic,
    }, function () {
      this.on('play', () => {
        _this.is_play = true;
      });
    });
    this.getUserInfo();
    this.scrollToTop();
    this.times = setInterval(() => {
      if (this.is_play && this.is_see == 0 && this.player) {
        const ct = Math.round(this.player.currentTime());
        if (ct >= 180) {
          this.player.pause();
          this.$toast(this.$t('video.buy'));
        }
      }
    }, 2000);
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
    clearInterval(this.times);
  },
};
</script>

<style scoped>
.play {
  min-height: 100vh;
  background: #fff;
  padding-bottom: 40px;
}
.bar {
  height: 88px;
  background: #ff2d6f;
  display: flex;
  align-items: center;
  padding: 0 16px;
}
.back {
  color: #fff;
  font-size: 56px;
  line-height: 1;
  padding: 0 12px;
}
.player {
  background: #000;
}
.player ::v-deep .video-js {
  width: 100%;
  height: 420px;
  font-size: 24px;
}
.player ::v-deep .vjs-poster {
  background-size: contain;
  background-color: #000;
}
.player ::v-deep .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-left: -1.5em;
  margin-top: -0.8em;
  background: rgba(0,0,0,.45);
  border: 0;
  border-radius: 50%;
  width: 3em;
  height: 3em;
  line-height: 3em;
}
.intro {
  padding: 20px 24px 12px;
}
.intro-title {
  font-size: 32px;
  font-weight: 800;
  color: #222;
  line-height: 1.4;
}
.intro-desc {
  margin: 8px 0 0;
  font-size: 24px;
  color: #888;
  line-height: 1.55;
}
.hot-head {
  display: flex;
  align-items: center;
  font-size: 30px;
  font-weight: 800;
  color: #222;
  margin: 8px 24px 16px;
}
.hot-head::before {
  content: "";
  width: 8px;
  height: 28px;
  background: #ff2d6f;
  border-radius: 8px;
  margin-right: 10px;
}
.grid {
  display: flex;
  flex-wrap: wrap;
  padding: 0 12px;
}
.card {
  width: 50%;
  padding: 6px;
  box-sizing: border-box;
}
.card img {
  width: 100%;
  height: 240px;
  object-fit: cover;
  display: block;
  border-radius: 6px;
  background: #111;
}
</style>
